import { render, staticRenderFns } from "./FormatListView.vue?vue&type=template&id=5cf3a022&scoped=true&"
import script from "./FormatListView.vue?vue&type=script&lang=ts&"
export * from "./FormatListView.vue?vue&type=script&lang=ts&"
import style0 from "./FormatListView.vue?vue&type=style&index=0&id=5cf3a022&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cf3a022",
  null
  
)

export default component.exports